module.exports = __webpack_public_path__ + "media/application/images/logo-trans-67dd108dd1b74b86d388fecfd07b5d63.png";